import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, MapPin } from 'lucide-react';

export const HeroSection = ({ t }) => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1920&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Logo */}
        <div className="mb-8 animate-fade-in">
          <div className="relative inline-block">
            <img
              src="https://customer-assets.emergentagent.com/job_lodge-website/artifacts/t81s6amh_1000015829.png"
              alt="Outaouais Big Game Logo"
              className="h-48 w-48 mx-auto object-contain drop-shadow-2xl"
            />
          </div>
          <p className="text-gray-400 text-sm mt-3">Permis de pourvoirie 07-919</p>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight">
          {t.hero.title}
        </h1>
        
        <p className="text-xl md:text-3xl text-orange-500 font-semibold mb-4">
          {t.hero.subtitle}
        </p>
        
        <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
          {t.hero.description}
        </p>

        {/* Location Badge */}
        <div className="flex items-center justify-center mb-10 text-gray-300">
          <MapPin className="h-5 w-5 text-orange-500 mr-2" />
          <span className="text-sm md:text-base">Outaouais, Québec</span>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={scrollToContact}
            size="lg"
            className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-8 py-6 text-lg transition-all duration-300 hover:scale-105 shadow-xl"
          >
            {t.hero.cta}
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          
          <Button
            onClick={scrollToAbout}
            size="lg"
            variant="outline"
            className="border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white font-semibold px-8 py-6 text-lg transition-all duration-300"
          >
            {t.hero.ctaSecondary}
          </Button>
        </div>

        {/* Launch Video */}
        <div className="mt-12 mb-16 max-w-3xl mx-auto">
          <div className="rounded-xl overflow-hidden border-2 border-orange-500/50 shadow-2xl shadow-orange-500/20 bg-black">
            <video
              data-testid="hero-launch-video"
              src="/videos/lancement-obgh.mp4"
              className="w-full max-h-[70vh] object-contain bg-black"
              autoPlay
              muted
              loop
              playsInline
              controls
            />
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-orange-500 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-orange-500 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};
